/** Account-lifecycle product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id, roleEnum } from './_shared.js';

export const accountEvents = {
  'account.created': {
    schema: z.object({
      account_id: id,
      signup_source: z.enum(['organic', 'agent_referral', 'marketing', 'admin', 'invite', 'waitlist']),
      referrer_agent_slug: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.slug_renamed': {
    schema: z.object({
      account_id: id,
      old_slug: z.string().optional(),
      new_slug: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.logo_uploaded': {
    schema: z.object({ account_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.closed': {
    schema: z.object({ account_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.member_invited': {
    schema: z.object({
      account_id: id,
      role: roleEnum,
      invite_method: z.enum(['email', 'link']).optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.member_joined': {
    schema: z.object({
      account_id: id,
      member_user_id: id,
      accepted_via: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.member_role_changed': {
    schema: z.object({
      account_id: id,
      member_user_id: id,
      old_role: roleEnum,
      new_role: roleEnum,
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'account.member_removed': {
    schema: z.object({
      account_id: id,
      member_user_id: id,
      removed_by: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
